import type { Database } from "@shared/database.types";
import type { Tag } from "./_shared";

export type JobStatus = Database["public"]["Enums"]["job_status"];
export type ReviewStatus = Database["public"]["Enums"]["review_status"];
export type PayStatus = Database["public"]["Enums"]["pay_status"];

export const JOB_STATUS_LABELS: Record<JobStatus, string> = {
  draft: "Draft",
  open: "Open",
  claimed: "Claimed",
  cancelled: "Cancelled",
  expired: "Expired",
};

export const REVIEW_STATUS_LABELS: Record<ReviewStatus, string> = {
  ready_to_review: "Ready to Review",
  approved: "Approved",
  rejected: "Rejected",
};

export const PAY_STATUS_LABELS: Record<PayStatus, string> = {
  unpaid: "Unpaid",
  paid: "Paid",
};

export const JOB_STATUS_OPTIONS: Tag[] = (
  Object.keys(JOB_STATUS_LABELS) as JobStatus[]
).map((value) => ({ value, label: JOB_STATUS_LABELS[value] }));

export const REVIEW_STATUS_OPTIONS: Tag[] = (
  Object.keys(REVIEW_STATUS_LABELS) as ReviewStatus[]
).map((value) => ({ value, label: REVIEW_STATUS_LABELS[value] }));

export const PAY_STATUS_OPTIONS: Tag[] = (
  Object.keys(PAY_STATUS_LABELS) as PayStatus[]
).map((value) => ({ value, label: PAY_STATUS_LABELS[value] }));

export function jobStatusLabel(value: JobStatus | null | undefined): string | null {
  return value ? JOB_STATUS_LABELS[value] : null;
}

export function reviewStatusLabel(
  value: ReviewStatus | null | undefined
): string | null {
  return value ? REVIEW_STATUS_LABELS[value] : null;
}

export function payStatusLabel(value: PayStatus | null | undefined): string | null {
  return value ? PAY_STATUS_LABELS[value] : null;
}
